import type {
  ChartOptions,
  FontSpec,
  GridLineOptions,
  TickOptions,
} from 'chart.js';

import type { Colors } from 'src/theme/paletteColors';
import type { WidgetChartConfigCamelized } from 'src/types/dashboard';

const labelValues: FontSpec = {
  family: '"Inter", sans-serif',
  size: 13,
  weight: 600,
  style: 'normal',
  lineHeight: 1.2,
};

interface extraOptions {
  gridOptions?: Partial<GridLineOptions>;
  tickOptions?: Partial<TickOptions>;
}

export const getOptions = (
  colors: Colors,
  chartConfig: WidgetChartConfigCamelized,
  dataGaps: number[],
  extraOptions?: extraOptions,
): ChartOptions<'line'> => ({
  maintainAspectRatio: false,
  responsive: true,
  plugins: {
    annotation: {
      annotations: dataGaps.map((gapIndex) => ({
        type: 'box',
        xMin: gapIndex - 0.5,
        xMax: gapIndex + 0.5,
        backgroundColor: colors.neutral[50],
        borderWidth: 0,
        drawTime: 'beforeDraw',
      })),
    },
    datalabels: {
      backgroundColor: colors.secondary[400],
      borderColor: colors.secondary[400],
      borderRadius: 4,
      color: colors.secondary[800],
      font: {
        weight: 'bold',
      },
      padding: { top: 3, right: 8, left: 8, bottom: 3 },
    },
  },
  scales: {
    x: {
      axis: 'x',
      ticks: {
        font: labelValues,
        color: colors.neutral[600],
      },
      title: {
        display: false,
      },
      grid: {
        display: false,
      },
      border: { display: false },
    },
    y: {
      axis: 'y',
      ticks: {
        stepSize: chartConfig.yAxisStepSize || 25,
        font: labelValues,
        color: colors.neutral[600],
        ...(extraOptions?.tickOptions ? extraOptions.tickOptions : {}),
      },
      suggestedMax: chartConfig.yAxisMax ?? 100,
      suggestedMin: chartConfig.yAxisMin ?? -100,
      title: {
        display: false,
      },
      grid: {
        color: colors.neutral[100],
        display: true,
        ...(extraOptions?.gridOptions ? extraOptions.gridOptions : {}),
      },
      border: { display: false },
    },
  },
});
